<mat-checkbox [ngModel]="value" (click)="next()" [disabled]="disabled" [indeterminate]="value === false" [color]="value === false ? 'warn' : 'primary'">
  <ng-container (click)="next()">
  <ng-content></ng-content>
  </ng-container>
</mat-checkbox>

